import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';

export function usePlatformChatMessageAttachmentsQuery(
  sessionId: string,
  messageId: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const isEnabled =
    (options?.enabled ?? true) &&
    Boolean(user) &&
    sessionId.length > 0 &&
    messageId.length > 0 &&
    !messageId.startsWith('local-');

  return useQuery({
    queryKey: chatQueryKeys.messageAttachments(sessionId, messageId),
    enabled: isEnabled,
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: () =>
      platformChatService.listMessageAttachments(sessionId, messageId),
  });
}
